import React from 'react';

import crIcon from 'src/assets/cr.png';
import investmentIcon from 'src/assets/investments.png';
import mortgageIcon from 'src/assets/mortgage.png';
import guaranteeIcon from 'src/assets/guarantee.svg';
import accountIcon from 'src/assets/account.png';
import dashboardIcon from 'src/assets/dashboard.png';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';
import { PAGE_ROUTE } from 'src/constants/route';
import { IUserStore } from 'src/store/user';
import useStore from './useStore';
import { IOnboardingStore } from 'src/store/user/onboarding.store';
import { ONBOARDING_STATUSES } from 'src/constants';

const useMenuItem = () => {
	const [t] = useTranslation();
	const userStore: IUserStore = useStore('userStore');

	const onboardingStore: IOnboardingStore = useStore<IOnboardingStore>('onboardingStore');

	const menu = [
		{
			id: PAGE_ROUTE.DASHBOARD,
			icon: <img src={dashboardIcon} width={27} height={27} />,
			title: `${t(i18nKey.dashboard.menu.home)}`,
			isActive: false
		},
		{
			id: PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_ACCOUNT),
			icon: <img src={accountIcon} width={27} />,
			title: `${t(i18nKey.dashboard.menu.account)}`,
			isActive: true
		}
	];
	const hasDashBoardMenu = [
		{
			id: PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_CHANGE_REQUEST),
			icon: <img src={crIcon} width={27} />,
			title: `${t(i18nKey.dashboard.menu.changeRequest)}`,
			isActive: false
		}
	];
	if (userStore.hasDashboard) {
		menu.push(...hasDashBoardMenu);
	}
	if (onboardingStore.funderOnboardingRequest?.status == ONBOARDING_STATUSES.SignedFSA) {
		menu.push({
			// id: PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_INVESTMENT),
			id: PAGE_ROUTE.COMMING_SOON,
			icon: <img src={investmentIcon} width={27} />,
			title: `${t(i18nKey.dashboard.menu.investment)}`,
			isActive: false
		});
	}
	if (onboardingStore.borrowerOnboardingRequest?.status == ONBOARDING_STATUSES.Approved) {
		menu.push({
			// id: PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_MORTGAGE),
			id: PAGE_ROUTE.COMMING_SOON,
			icon: <img src={mortgageIcon} width={27} />,
			title: `${t(i18nKey.dashboard.menu.mortgageDeal)}`,
			isActive: false
		});
		menu.push({
			// id: PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_GUARANTEE),
			id: PAGE_ROUTE.COMMING_SOON,
			icon: <img src={guaranteeIcon} width={27} height={27} />,
			title: `${t(i18nKey.dashboard.menu.guarantee)}`,
			isActive: false
		});
	}
	return menu;
};
export default useMenuItem;
